import s from './User.scss'
import cn from 'classnames'
import { Summary } from '../Summary'

const User = ({ user, totals }) => {
  return (
    <div className={s.container}>
      <img className={s.image} src={user.photo || '/images/no_picture.png'} />
      <div className={s.bold}>{user.fullName}</div>
      <p className={s.role}>{user.role}</p>
      <div className={s.totals}>
        <div className={cn(s.flex, s.bold, s.header)}>
          <span>TOTAL</span>
          <span>{totals.total} hrs</span>
        </div>
        {totals.statuses.map(status => (
          <div key={status.name} className={cn(s.flex, s.status)}>
            <span>{status.name}</span>
            <span>{status.hours} hrs</span>
          </div>
        ))}
        <br />
        <Summary summary={totals} style={{ minWidth: 160 }} />
      </div>
    </div>
  )
}

export default User
